import { TourStep } from "../page-tour.component";

export const MY_JOURNEY_TOUR_STEPS: TourStep[] = [
  {
    title: "tour.myJourney.s1.title",
    description: "tour.myJourney.s1.desc",
    icon: "ft-book-open",
    accentGradient:
      "linear-gradient(135deg, hsl(221, 83%, 53%) 0%, hsl(250, 55%, 50%) 50%, hsl(280, 60%, 55%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(221, 83%, 68%), hsl(250, 55%, 50%))",
    svgPath:
      "M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2zM22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z",
  },
  {
    title: "tour.myJourney.s2.title",
    description: "tour.myJourney.s2.desc",
    icon: "ft-bar-chart-2",
    accentGradient:
      "linear-gradient(135deg, hsl(221, 83%, 53%) 0%, hsl(152, 68%, 38%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(152, 56%, 54%), hsl(221, 83%, 53%))",
    svgPath: "M18 20V10M12 20V4M6 20v-6",
  },
  {
    title: "tour.myJourney.s3.title",
    description: "tour.myJourney.s3.desc",
    icon: "ft-edit-3",
    accentGradient:
      "linear-gradient(135deg, hsl(25, 84%, 50%) 0%, hsl(32, 88%, 60%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(32, 88%, 65%), hsl(25, 84%, 50%))",
    svgPath: "M12 20h9M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z",
  },
  {
    title: "tour.myJourney.s4.title",
    description: "tour.myJourney.s4.desc",
    icon: "ft-plus-circle",
    accentGradient:
      "linear-gradient(135deg, hsl(221, 83%, 53%) 0%, hsl(200, 75%, 50%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(200, 75%, 60%), hsl(221, 83%, 53%))",
    svgPath:
      "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM12 8v8M8 12h8",
  },
  {
    title: "tour.myJourney.s5.title",
    description: "tour.myJourney.s5.desc",
    icon: "ft-filter",
    accentGradient:
      "linear-gradient(135deg, hsl(250, 55%, 50%) 0%, hsl(221, 83%, 53%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(250, 68%, 63%), hsl(221, 83%, 53%))",
    svgPath: "M22 3H2l8 9.46V19l4 2v-8.54L22 3z",
  },
  {
    title: "tour.myJourney.s6.title",
    description: "tour.myJourney.s6.desc",
    icon: "ft-clock",
    accentGradient:
      "linear-gradient(135deg, hsl(152, 68%, 38%) 0%, hsl(170, 55%, 45%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(152, 56%, 54%), hsl(170, 55%, 45%))",
    svgPath: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM12 6v6l4 2",
  },
  {
    title: "tour.myJourney.s7.title",
    description: "tour.myJourney.s7.desc",
    icon: "ft-zap",
    accentGradient:
      "linear-gradient(135deg, hsl(152, 68%, 38%) 0%, hsl(221, 83%, 53%) 50%, hsl(250, 55%, 50%) 100%)",
    orbGradient:
      "radial-gradient(circle at 30% 30%, hsl(152, 56%, 54%), hsl(221, 83%, 53%))",
    svgPath: "M13 2L3 14h9l-1 8 10-12h-9l1-8z",
  },
];
